export const ccm = {
  diagnosesDialog: {
    chronicChip: 'Chronic'
  },
  filterCustomButton: {
    asynchronous: 'Asynchronous',
    synchronous: 'Synchronous'
  },
  filters: {
    firstNameLabel: 'First Name',
    lastNameLabel: 'Last Name',
    checkEligibilityTitle: 'Check CCM Eligibility',
    pendingConsentLabel: 'Pending Consent',
    pendingSignOffLabel: 'Pending Sign-Off',
    checkEligibilityLabel: 'Check Eligibility',
    removeFromServiceLabel: 'Remove From Service'
  },
  dataGrid: {
    supportingDataTitle: 'Supporting Data',
    patientDiagnosesTitle: 'Patient Diagnoses',
    tagPatientTooltip: 'Tag Patient',
    viewSupportingDataTooltip: 'View Supporting Data',
    scheduleForEnrollmentTooltip: 'Schedule for Enrollment',
    columns: {
      nameLastFirst: 'Name (Last, First)',
      phoneNumber: 'Phone number',
      dob: 'DOB',
      diagnoses: 'Diagnoses',
      supportingData: 'Supporting Data',
      lastVisitDate: 'Last Visit Date',
      enrollmentMode: 'Enrollment Mode',
      enrolledDate: 'Enrolled Date',
      unenrolledDate: 'Unenrolled Date',
      encounterStart: 'Encounter Start',
      scheduledVisit: 'Scheduled Visit',
      encounterMode: 'Encounter Mode',
      encounterStatus: 'Encounter Status',
      actions: 'Actions'
    }
  },
  tabs: {
    candidates: 'Candidates',
    eligible: 'Eligible',
    ineligible: 'Ineligible',
    inProgress: 'In Progress',
    scheduled: 'Scheduled',
    enrolled: 'Enrolled',
    attributedElsewhere: 'Attributed Elsewhere',
    unenrolled: 'Unenrolled'
  },
  metaDataDialog: {
    patientInformationHeading: 'Patient Information',
    nameLabel: 'Name',
    birthDateLabel: 'Birth Date',
    genderLabel: 'Gender',
    statusLabel: 'Status',
    addressLabel: 'Address',
    allergyLabel: 'Allergy',
    clinicalStatusLabel: 'Clinical Status',
    verificationStatusLabel: 'Verification Status',
    classLabel: 'Class',
    startDateLabel: 'Start Date',
    endDateLabel: 'End Date',
    vaccineLabel: 'Vaccine',
    dateLabel: 'Date',
    observationLabel: 'Observation',
    valueLabel: 'Value',
    intentLabel: 'Intent',
    descriptionLabel: 'Description',
    categoriesLabel: 'Categories',
    fhirBundleDataHeading: 'FHIR Bundle Data'
  }
} as const;
